/* eslint-disable camelcase */
export const state = () => ({
  menuOpened: false,
  cartOpened: false,
  products: [],
  posts: [],
  token: null,
  user: null,
  myProducts: [],
  myFavorites: [],
  favoritesCount: null,
  myWatchlist: [],
  patientId: null,
  menu: null,
  currency: process.env.CURRENCY_SYMBOL,
  prices: [],
  tags: [],
  categories: [],
  tagsFilter: [],
  categoriesFilter: [],
  sortCriteria: null,
  sortName: null,
  cart: [],
  regions: [],
  order: {},
  orderId: null,
  // savedCards: [],
  marketing: true,
  terms: false,
  contactFormOpened: false,
  chatFormOpened: false,
  chatFormSent: false,
  clinics: [],
  gmapLoaded: false,
  staff: [],
  recipes: [],
  recipeCategories: [],
  blogCategories: [],
  isPost: false,
  closestClinicId: null,
  deliveryAddress: [],
  options: [],
  loginMessage: null,
  loginOpened: false,
  testimonials: [],
  // activeCard: null,
  mbDetails: null,
  filterOpen: false,
  inShop: false,
  method: 'mbway',
  mbwayPending: false,
  eKwanzaPending: false,
  kwanzaQr: null,
  cookies: false,
  usePoints: false,
  shippingLeft: undefined,
  calculatedShipping: null,
  calculatedZip: null,
  utm: {},
  promoOpened: true,
  checkoutStep: 1,
  removedItems: [],
  updatedItems: [],
  couponCode: '',
  isOrderCreating: false,
  isOrderUpdating: false,
  freeShippingCouponLimit: undefined,
  freeShippingCouponLeft: undefined,
  gtmOverride: null,
  showNavbar: true,
});

export const mutations = {
  addRemovedItem(state, item) {
    if (!state.removedItems.find((p) => p.sku === item.sku)) {
      state.removedItems.push(item);
    }
  },

  addUpdatedItem(state, item) {
    if (!state.updatedItems.find((p) => p.sku === item.sku)) {
      state.updatedItems.push(item);
    }
  },

  clearRemovedItems(state) {
    state.removedItems = [];
  },

  clearUpdatedItems(state) {
    state.updatedItems = [];
  },

  setMethod: (state, value) => {
    state.method = value;
  },

  openLoginModal: (state) => {
    state.loginOpened = true;
  },

  closeLoginModal: (state) => {
    state.loginOpened = false;
  },

  setCheckoutStep: (state, value) => {
    state.checkoutStep = value;
  },

  setUtmParams: (state, params) => {
    state.utm = params;
  },

  setRegions: (state, regions) => {
    state.regions = regions;
  },

  setMbwayPending: (state, data) => {
    state.mbwayPending = data;
  },

  setEKwanzaPending: (state, data) => {
    state.eKwanzaPending = data.pending;
    state.kwanzaQr = data.qr;
  },

  openMenu: (state) => (state.menuOpened = true),

  closeMenu: (state) => (state.menuOpened = false),

  toggleMenu: (state) => (state.menuOpened = !state.menuOpened),

  updateFavoritesCount: (state, data) => {
    if (data) {
      state.favoritesCount = state.favoritesCount + data;
    } else {
      state.favoritesCount = state.myFavorites.length;
    }
  },

  updateFavorites: (state, sku) => {
    const index = state.myFavorites.findIndex((f) => f.sage_id === sku);

    if (index !== -1) {
      // remove from the favorites
      state.myFavorites.splice(index, 1);
    } else {
      // add to the favorites
      state.myFavorites.push({ sage_id: sku });
    }
  },

  addTestimonial: (state, data) => {
    if (!state.testimonials.map((c) => c.id).includes(data.id)) {
      state.testimonials.push(data);
    }
  },

  turnOffCookies: (state) => (state.cookies = true),

  setInShop: (state) => (state.inShop = true),

  setNotInShop: (state) => (state.inShop = false),

  closeFilter: (state) => (state.filterOpen = false),

  toggleFilter: (state) => (state.filterOpen = !state.filterOpen),

  setIsPost: (state, value) => (state.isPost = value),

  setTestimonials: (state, data) => (state.testimonials = data),

  setClosestClinic: (state, id) => (state.closestClinicId = id),

  setRecipeCategories: (state, data) => (state.recipeCategories = data),

  setBlogCategories: (state, data) => (state.blogCategories = data),

  setStaff: (state, data) => (state.staff = data),

  markGmapAsLoaded: (state) => (state.gmapLoaded = true),

  openContactForm: (state) => (state.contactFormOpened = true),

  closeContactForm: (state) => (state.contactFormOpened = false),

  toggleContactForm: (state) =>
    (state.contactFormOpened = !state.contactFormOpened),

  openChatForm: (state) => (state.chatFormOpened = true),

  closeChatForm: (state) => (state.chatFormOpened = false),

  toggleChatForm: (state) => (state.chatFormOpened = !state.chatFormOpened),

  openPromo: (state) => (state.promoOpened = true),

  closePromo: (state) => (state.promoOpened = false),

  togglePromo: (state) => (state.promoOpened = !state.promoOpened),

  openCart: (state) => {
    state.cartOpened = true;
    document.querySelector(':root').classList.add('no-scroll');
  },

  closeCart: (state) => {
    state.cartOpened = false;
    document.querySelector(':root').classList.remove('no-scroll');
  },

  toggleCart: (state) => (state.cartOpened = !state.chatFormOpened),

  setChatFormSent: (state) => (state.chatFormSent = true),

  setChatFormUnsent: (state) => (state.chatFormSent = false),

  setRecipes: (state, data) => {
    const recipes = [...state.recipes, ...data];
    state.recipes = recipes.filter(
      (value, index, array) =>
        array.findIndex((r) => r.id === value.id) === index
    );
  },

  addRecipe(state, data) {
    if (!state.recipes.map((c) => c.id).includes(data.id)) {
      state.recipes.push(data);
    }
  },

  setClinics: (state, data) => {
    state.clinics = data.sort((a, b) => {
      return new Intl.Collator(process.env.VUE_APP_LANG).compare(
        a.title.rendered,
        b.title.rendered
      );
    });
  },

  addClinic(state, data) {
    if (!state.clinics.map((c) => c.id).includes(data.id)) {
      state.clinics.push(data);
    }
  },

  setLoginMessage(state, message) {
    state.loginMessage = message;
  },

  setProducts(state, data) {
    const products = [
      ...state.products,
      ...data.filter((p) => state.prices.find((sp) => p.sku === sp.sku)),
    ];
    state.products = products.filter(
      (value, index, array) =>
        array.findIndex((p) => p.id === value.id) === index
    );
  },

  setMyProducts(state, data) {
    const myProducts = [...state.myProducts, ...data];
    state.myProducts = myProducts.filter(
      (value, index, array) =>
        array.findIndex((p) => p.id === value.id) === index
    );
  },

  addProducts(state, products) {
    const productsToAdd = Array.isArray(products) ? products : [products];
    const existingIds = new Set(state.products.map((p) => p.id));

    const newUniqueProducts = productsToAdd.filter((product) => {
      return product && product.id && !existingIds.has(product.id);
    });

    state.products = [...state.products, ...newUniqueProducts];
  },

  setOptions(state, value) {
    state.options = value;
  },

  setMarketing(state, value) {
    state.marketing = value;
  },

  setTerms(state, value) {
    state.terms = value;
  },

  setMbDetails(state, value) {
    state.mbDetails = value;
  },

  setPosts(state, data) {
    const posts = [...state.posts, ...data];
    state.posts = posts.filter(
      (value, index, array) =>
        array.findIndex((p) => p.id === value.id) === index
    );
  },

  setToken(state, token) {
    state.token = token;
  },

  setUser(state, data) {
    state.user = data ? data.user : null;
    state.myProducts = data ? data.myProducts : [];
    state.myFavorites = data && data.favorites ? data.favorites : [];
    state.myWatchlist = data && data.watched ? data.watched : [];
    state.favoritesCount = state.myFavorites.length;
  },

  setDeliveryAddress(state, deliveryAddress) {
    state.deliveryAddress = deliveryAddress;
  },

  addDeliveryAddress(state, address) {
    state.deliveryAddress = [];
    state.deliveryAddress.push(address);
  },

  setShippingLeft(state, value) {
    state.shippingLeft = parseFloat(value);
  },

  setCalculatedZip(state, value) {
    state.calculatedZip = value;
  },

  setCalculatedShipping(state, value) {
    state.calculatedShipping = value;
  },

  setPatientId(state, id) {
    state.patientId = id;
  },

  setMenu(state, menu) {
    state.menu = menu;
  },

  setPrices(state, prices) {
    state.prices = [...prices];
  },

  setCategories(state, categories) {
    state.categories = [...categories];
  },

  setTags(state, tags) {
    state.tags = [...tags];
  },

  addTagFilter(state, tag) {
    state.tagsFilter.push(tag);
  },

  removeTagFilter(state, tag) {
    const index = state.tagsFilter.findIndex((t) => t === tag);
    if (index > -1) {
      state.tagsFilter.splice(index, 1);
    }
  },

  resetTagFilter(state) {
    state.tagsFilter = [];
  },

  addCategoryFilter(state, category) {
    state.categoriesFilter.push(category);
  },

  removeCategoryFilter(state, category) {
    const index = state.categoriesFilter.findIndex((c) => c === category);
    if (index > -1) {
      state.categoriesFilter.splice(index, 1);
    }
  },

  resetCategoryFilter(state) {
    state.categoriesFilter = [];
  },

  setSortCriteria(state, criteria) {
    if (criteria) {
      state.sortCriteria = criteria.type;
      state.sortName = criteria.name;
    } else {
      state.sortCriteria = null;
      state.sortName = null;
    }
  },

  clearCart(state) {
    state.cart = [];
  },

  clearOrder(state) {
    state.order = {};
    state.orderId = null;
  },

  editCartItem(state, { quantity, sku }) {
    const index = state.cart.findIndex((r) => r.sku === sku && !r.free_product);
    if (index > -1) {
      state.cart[index].quantity = quantity;
    }
  },

  removeCartItem(state, { sku, free_product }) {
    const index = state.cart.findIndex(
      (r) => r.sku === sku && Boolean(r.free_product) === Boolean(free_product)
    );
    if (index > -1) {
      state.cart.splice(index, 1);
    }
  },

  makeCartFromOrder(state, order) {
    state.cart = [
      ...order.order_rows.map((r) => ({
        quantity: r.quantity,
        on_sale: r.on_sale,
        sku: r.sku,
        unit_price: r.unit_price || 0,
        price: r.unit_price || 0,
        regularPrice: r.regular_price || 0,
        free_product: r.free_product || false,
        categories: r.wc_categories,
      })),
    ];
  },

  addToCart(
    state,
    {
      quantity,
      sku,
      price,
      regularPrice,
      salePrice,
      onSale,
      categories,
      free_product = false,
    }
  ) {
    const index = state.cart.findIndex(
      (r) => r.sku === sku && Boolean(r.free_product) === Boolean(free_product)
    );
    if (index > -1) {
      state.cart[index].quantity += quantity;
    } else {
      state.cart.push({
        quantity,
        sku,
        on_sale: onSale,
        unit_price: price,
        regular_price: parseFloat(regularPrice),
        sale_price: salePrice ? parseFloat(salePrice) : null,
        categories,
        free_product,
      });
    }
  },

  setOrder(state, order) {
    state.order = { ...order };
  },

  setOrderId(state, orderId) {
    state.orderId = orderId;
  },

  updateDeliveryAddresses(state, address) {
    state.deliveryAddress = state.deliveryAddress.map((a) => {
      const addressToChange = state.deliveryAddress.find(
        (a) => a.id === address.id
      );
      return addressToChange ? address : a;
    });
  },

  setPoints(state, value) {
    state.usePoints = value;
  },

  setCouponCode(state, code) {
    state.couponCode = (code || '').trim();
    if (!code) {
      state.freeShippingCouponLimit = undefined;
      state.freeShippingCouponLeft = undefined;
    }
  },

  clearCoupon(state) {
    state.couponCode = '';
  },

  setOrderCreating(state, isCreating) {
    state.isOrderCreating = isCreating;
  },

  setOrderUpdating(state, isUpdating) {
    state.isOrderUpdating = isUpdating;
  },

  setFreeShippingCouponLimit(state, thisFreeShippingCouponLimit) {
    state.freeShippingCouponLimit = thisFreeShippingCouponLimit;
  },

  setFreeShippingCouponLeft(state, thisFreeShippingCouponLeft) {
    state.freeShippingCouponLeft = thisFreeShippingCouponLeft;
  },

  setGtmOverride(state, payload) {
    state.gtmOverride = payload || null;
  },
  clearGtmOverride(state) {
    state.gtmOverride = null;
  },

  setShowNavbar(state, payload) {
    state.showNavbar = payload;
  },
};

export const getters = {
  getClinic: (state) => (slug) => state.clinics.find((c) => c.slug === slug),

  getRecipe: (state) => (slug) => state.recipes.find((c) => c.slug === slug),

  getStaff: (state) => (id) => state.staff.find((s) => s.id === id),

  subTotal: (state, getters) => {
    const sum = state.cart.reduce((acc, curr) => {
      const currentPrice = getters.getActualPrice(curr.sku);
      acc += currentPrice * curr.quantity;
      return acc;
    }, 0);
    return parseFloat(sum.toFixed(2));
  },

  cartQuantity: (state) => {
    return state.cart.reduce((acc, curr) => (acc += curr.quantity), 0);
  },

  getProductBg: (state) => (sku) => {
    const product = state.products.find((p) => p.sku === sku);
    return product ? product.acf.background_color : null;
  },

  getProductCategoryName: (state) => (sku) => {
    const product = state.products.find((p) => p.sku === sku);
    return product?.categories?.length
      ? product.categories[0].name.replace(/&amp;/gi, '&')
      : null;
  },

  getQuantity: (state) => (sku) => {
    const row = state.cart.find((r) => r.sku === sku && !r.free_product);
    return row ? row.quantity : 0;
  },

  getPrices: (state) => {
    return state.prices;
  },

  getPrice: (state) => (sku) => {
    const price = state.prices.find((p) => p.sku === sku);
    return price ? Number(price.price) : null;
  },

  getActualPrice: (state, getters) => (sku) => {
    const product = state.products.find((p) => p.sku === sku);
    if (product && product.on_sale) {
      if (
        (product.date_on_sale_from_gmt &&
          new Date() < new Date(product.date_on_sale_from_gmt + 'Z')) ||
        (product.date_on_sale_to_gmt &&
          new Date() > new Date(product.date_on_sale_to_gmt + 'Z')) ||
        !product.sale_price ||
        product.sale_price >= getters.getPrice(sku)
      ) {
        return getters.getPrice(sku);
      }
      return Number(product.sale_price);
    }
    return getters.getPrice(sku);
  },

  getProductImages: (state) => (sku) => {
    const product = state.products.find((p) => p.sku === sku);
    return product ? product.images : [];
  },

  getProductName: (state) => (sku) => {
    const product = state.products.find((p) => p.sku === sku);
    return product ? product.name : null;
  },

  getProductBrand: (state) => (sku) => {
    const product = state.products.find((p) => p.sku === sku);
    const brand = product.attributes.find((a) => a.name === 'brand');
    return brand || 'Lev';
  },

  getProductSlug: (state) => (sku) => {
    const product = state.products.find((p) => p.sku === sku);
    return product ? product.slug : null;
  },

  getStock: (state) => (sku) => {
    const price = state.prices.find((p) => p.sku === sku);
    return price && price.product
      ? {
          in_stock: price.product.in_stock,
          low_stock: price.product.low_stock,
          stock: price.product.stock,
        }
      : null;
  },

  getCategoryBySlug: (state) => (slug) => {
    return state.categories.find((c) => c.slug === slug);
  },

  getBlogCategoryBySlug: (state) => (slug) => {
    return state.blogCategories.find((c) => c.slug === slug);
  },

  filterProducts: (state) => (products) => {
    const productsVisible = products.filter((p) => !p?.acf?.hide_product);
    const filteredByCategories =
      state.categoriesFilter.length === 0
        ? [...productsVisible]
        : [
            ...productsVisible.filter(
              (p) =>
                Array.isArray(p.categories) &&
                p.categories.some((c) => state.categoriesFilter.includes(c.id))
            ),
          ];
    const filteredByTags =
      state.tagsFilter.length === 0
        ? [...filteredByCategories]
        : [
            ...filteredByCategories.filter(
              (p) =>
                Array.isArray(p.tags) &&
                p.tags.some((t) => state.tagsFilter.includes(t.id))
            ),
          ];
    return filteredByTags;
  },

  sortProducts: (state, getters) => (products) => {
    if (state.sortCriteria === null) {
      return [...products.sort((a, b) => (a.featured && !b.featured ? -1 : 0))];
    }
    let sortedProducts;
    const sortDirection = state.sortCriteria.split('_')[1];
    const criteria = state.sortCriteria.split('_')[0];
    if (criteria === 'name') {
      sortedProducts = [
        ...products.sort((a, b) => {
          return new Intl.Collator(process.env.VUE_APP_LANG).compare(
            a.name,
            b.name
          );
        }),
      ];
    } else if (criteria === 'price') {
      sortedProducts = [
        ...products.sort(
          (a, b) =>
            getters.getActualPrice(a.sku) - getters.getActualPrice(b.sku)
        ),
      ];
    } else {
      sortedProducts = [...products];
    }
    return sortDirection === 'asc'
      ? [...sortedProducts]
      : [...sortedProducts].reverse();
  },

  orderQuantity: (state) => {
    const rows = state.order ? state.order.order_rows : null;
    return rows && rows.length
      ? rows.reduce((acc, curr) => (acc += curr.quantity), 0)
      : 0;
  },

  freeShipping: (state) => {
    const coupons = state.order ? state.order.coupons : null;

    if (!coupons || coupons.length === 0) {
      return false;
    }
    return coupons.some((coupon) => coupon.free_shipping === 1);
  },

  couponCodeApplied: (state) => {
    const coupons = state.order ? state.order.coupons : null;

    if (!coupons || !state.couponCode) {
      return false;
    }

    return coupons.some((coupon) => coupon.code === state.couponCode);
  },
};

export const actions = {
  gtEvent: (_, event) => {
    if (process.env.NODE_ENV !== 'development')
      window.ga('send', {
        hitType: 'event',
        eventCategory: 'tracking',
        eventAction: event.action,
        eventLabel: event.label ? event.label : null,
        eventValue: event.value ? event.value : null,
      });
    else {
      console.log('googleEvent', event);
    }
  },

  async updateOrder({ commit, dispatch, state }) {
    if (state.cart.length === 0) {
      commit('clearOrder');
      return;
    }
    if (state.orderId === null || state.isOrderUpdating) return;
    commit('setOrderUpdating', true);
    try {
      const { data } = await this.app.$bolev.updateOrder({
        rows: state.cart,
        patientId: state.patientId,
        orderId: state.orderId,
      });
      if (data.status > 3) {
        dispatch('createOrder');
      } else {
        commit('setOrder', data);
        dispatch('addMissingRowsToCart', data);
        dispatch('calculateShipping', data);
      }
      if (state.usePoints) {
        dispatch('togglePoints', false);
      }
    } catch (e) {
      commit('clearOrder');
      return null;
    } finally {
      commit('setOrderUpdating', false);
    }
  },

  addMissingRowsToCart({ commit, state }, order) {
    const missingRows = order.order_rows.filter(
      (r) =>
        state.cart.findIndex(
          (cr) =>
            cr.sku === r.sku &&
            Boolean(cr.free_product) === Boolean(r.free_product)
        ) === -1
    );
    for (let k = 0; k < missingRows.length; k++) {
      commit('addToCart', {
        quantity: missingRows[k].quantity,
        sku: missingRows[k].sku,
        price: missingRows[k].unit_price || 0,
        regularPrice: missingRows[k].regular_price || 0,
        free_product: missingRows[k].free_product || false,
      });
    }
    const deletedRows = state.cart.filter(
      (r) =>
        order.order_rows.findIndex(
          (or) =>
            or.sku === r.sku &&
            Boolean(or.free_product) === Boolean(r.free_product)
        ) === -1
    );
    for (let j = 0; j < deletedRows.length; j++) {
      commit('removeCartItem', deletedRows[j]);
    }
  },

  async createOrder({ commit, dispatch, state }) {
    if (state.cart.length === 0 || state.orderId || state.creatingOrder) return;
    commit('setOrderCreating', true);
    try {
      const { data } = await this.app.$bolev.createOrder({
        rows: state.cart,
        patientId: state.patientId,
        source: 'Web',
      });
      commit('setOrder', data);
      dispatch('addMissingRowsToCart', data);
      commit('setOrderId', data.id);
      dispatch('calculateShipping', data);
      return data;
    } catch (e) {
      commit('clearOrder', {});
      return null;
    } finally {
      commit('setOrderCreating', false);
    }
  },

  async getOrder({ commit, state, dispatch }) {
    try {
      const { data } = await this.app.$bolev.getOrder({
        orderId: state.orderId,
        patientId: state.patientId,
      });
      if (data.status > 3) {
        dispatch('createOrder');
      } else {
        commit('setOrder', data);
        commit('setOrderId', data.id);
        dispatch('calculateShipping', data);
      }
      return data;
    } catch (e) {
      commit('clearOrder');
      return null;
    }
  },

  async calculateShipping({ commit, state, getters }, order) {
    if (order.address) {
      try {
        const { data } = await this.$bolev.getShipping({
          zip: order.address.zip,
          total: getters.subTotal,
          patientId: state.patientId,
        });
        commit('setCalculatedShipping', parseFloat(data.shipping));
        commit('setShippingLeft', data.left);
      } catch (error) {
        console.log(error);
      }
    }
  },

  async togglePoints({ commit, state }, value) {
    try {
      const { data } = await this.$bolev.levPoints({
        levPoints: value,
        orderId: state.order.id,
      });
      commit('setOrder', data);
      commit('setPoints', value);
    } catch (error) {
      console.log(error);
    }
  },
};
